<template lang="pug">

v-chip.hotness(
  v-if="name.trim()"
  label
  small
  :selected="selected"
  :close="close"
  :color="color"
  text-color="white"
  @input="listeners['close']()"
  @mouseover="showTooltip = true"
  @mouseleave="showTooltip = false"
  :id="`hotness-anchor-${contactKey}`"
) {{ name | truncate(maxLengthName) }}
  v-tooltip(
    v-if="showTooltip && !tooltipDisabled"
    :value="showTooltip"
    top
    :activator="`#hotness-anchor-${contactKey}`"
  )
    span {{ name  }}
</template>

<script>

import truncate from '@/Core/filters/truncateText';

const defaultHotnessColor = '#cccccc;';
const defaultHotnessName = ' ';

export default {
  props: {
    name: {
      type: String,
      required: false,
      default: defaultHotnessName,
    },
    color: {
      type: String,
      required: false,
      default: defaultHotnessColor,
    },
    selected: {
      type: Boolean,
      required: false,
      default: false,
    },
    close: {
      type: Boolean,
      required: false,
      default: false,
    },
    maxLengthName: {
      type: Number,
      required: false,
      default: 12,
    },
    contactKey: {
      default: 0,
    }
  },
  data () {
    return {
      showTooltip: false,
    }
  },
  watch: {
    contactKey(value) {
      this.showTooltip = false;
    }
  },
  filters: {
    truncate,
  },
  computed: {
    tooltipDisabled() {
      return this.maxLengthName > this.name.length;
    },
  }

};
</script>

<style lang="sass">

.v-chip.hotness
  text-shadow: 1.3px 1.3px 0.8px rgba(0, 0, 0, 0.6)

</style>
